import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { BASE_PATH } from './core/api';
import { authInterceptor } from './core/auth/token-interceptor';
import { tokenRefreshInterceptor } from './core/auth/token-refresh.interceptor'; 
import { httpErrorInterceptor } from './core/server-error.interceptor';
import { environment } from '../environments/environment';

// CloudFront reverse-proxies /clientservice/* to the API same-origin, so the
// SPA calls the API via a relative path (no CORS preflight). SSR has no window
// and local dev needs the absolute http://localhost:3001 — both keep using the
// configured environment.apiUrl.
function resolveApiBasePath(): string {
  if (typeof window === 'undefined') {
    return environment.apiUrl;
  }
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') {
    return environment.apiUrl;
  }
  try {
    return new URL(environment.apiUrl).pathname || '/clientservice';
  } catch {
    return '/clientservice';
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({
      scrollPositionRestoration: 'enabled'
    })),
    provideClientHydration(withEventReplay()),
    // tokenRefreshInterceptor is last: it must see a 403 TokenInvalid before httpErrorInterceptor logs out.
    provideHttpClient(withInterceptors([authInterceptor, httpErrorInterceptor, tokenRefreshInterceptor])),
    { provide: BASE_PATH, useValue: resolveApiBasePath() }
  ]
};
